import { capitalize } from 'lodash';
import {
	SaveButtonBaseProps,
	SaveButtonState,
	SaveDataLinkEvent,
} from '../SaveButtonProps';
import { SeriesItemData } from '../../cards/series-item-card/SeriesItemCardProps';
import { isCwpUserSignedIn } from '../../../../../_helpers/isCwpUserSignedIn';

export const getTooltipLabel = (
	props: SaveButtonBaseProps,
	stayedHovered: boolean
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
): string => {
	if (props.buttonState === SaveButtonState.UNSAVE_CLICKED) {
		return capitalize(props.tooltip.unsaved);
	} else if (props.buttonState === SaveButtonState.SAVE_CLICKED) {
		return capitalize(props.tooltip.saved);
	} else if (stayedHovered) {
		//If the user stayed on the button on desktop device after clicking don't show any tooltip
		return '';
	} else if (props.buttonState === SaveButtonState.SAVED) {
		return capitalize(props.tooltip.unsave);
	} else if (props.buttonState === SaveButtonState.UNSAVED) {
		return capitalize(props.tooltip.save);
	}
};

export const getAriaLabel = (props: SaveButtonBaseProps): string => {
	if (isSavedState(props.buttonState)) {
		return props.unsaveAriaLabel;
	}
	return props.saveAriaLabel;
};

export const isButtonVisible = (props: SaveButtonBaseProps): boolean => {
	// If the parent is hovered or focused, the button is visible
	if (!props.parentIsHovered && !props.parentIsFocusVisible) {
		if (
			props.buttonState === SaveButtonState.SAVED &&
			!props.savedDefaultIsVisible
		)
			return false;
		if (
			props.buttonState === SaveButtonState.UNSAVED &&
			!props.unsavedDefaultIsVisible
		)
			return false;
	}
	return true;
};

export const isSavedState = (buttonState: SaveButtonState): boolean => {
	return (
		buttonState === SaveButtonState.SAVED ||
		buttonState === SaveButtonState.SAVE_CLICKED
	);
};

export const getDataLinkEventSaveUnsave = (
	componentName: string,
	buttonState: SaveButtonState,
	item: SeriesItemData
): string => {
	if (!isCwpUserSignedIn()) {
		return `${componentName}|${SaveDataLinkEvent.LOGIN_TO_SAVE}`;
	}
	return getDataLinkEvent(
		componentName,
		item,
		isSavedState(buttonState)
			? SaveDataLinkEvent.UNSAVE
			: SaveDataLinkEvent.SAVE
	);
};

export const getDataLinkEventUndo = (
	componentName: string,
	item: SeriesItemData
): string => {
	return getDataLinkEvent(componentName, item, SaveDataLinkEvent.UNDO);
};

const getDataLinkEvent = (
	componentName: string,
	item: SeriesItemData,
	operation: string
): string => {
	return `${operation}|${componentName}|${item.itemType}|${item.contentCategory}|${item.contentTitle}`;
};
